import api from 'api'
import { CACHE_TAG_WORK_ORDER_DISPOSAL_TICKET } from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchWorkOrdersDisposalTicket: builder.query({
      query: workOrderId => ({ url: `/api/v1/core/work-orders/${workOrderId}/disposal-tickets`, method: 'GET' }),
      providesTags: [CACHE_TAG_WORK_ORDER_DISPOSAL_TICKET],
    }),
  }),
})

export const { useFetchWorkOrdersDisposalTicketQuery, useLazyFetchWorkOrdersDisposalTicketQuery } = extendedApi
